import { Button } from "reactstrap";
import Services from "./Services";

const JegyeladasFizetesButton = ({
  fizetesButtonLoading,
  bucket,
  event,
  init,
  rot,
  formNev,
  formFizetesiMod,
  formEmail,
  formBizonylatszam,
  formMegjegyzes,
  formVasarloiKartyaBySid,
  rendelesId,
  eszkozazonosito,
  CONSTANTS,
  setFizetesButtonLoading,
  addSuccess,
  goBack,
}) => {
  function handlePayButtonClick(e) {
    e.target.blur();

    setFizetesButtonLoading(true);

    const seattickets = bucket.map((bucketItem) => ({
      tdd: formVasarloiKartyaBySid[bucketItem.sid] && formVasarloiKartyaBySid[bucketItem.sid].azonosito,
      tdi: bucketItem.kedvezmeny && bucketItem.kedvezmeny.id,
      tid: bucketItem.ttid,
      sid: bucketItem.sid,
      id: bucketItem.id
    }));

    const adminPurchaseDto = {
      ste: 2,
      rid: event.rid,
      eid: event.eid,
      now: init.now,
      rot: rot.name,
      nam: formNev,
      pty: formFizetesiMod,
      ema: formEmail,
      rno: formBizonylatszam,
      not: formMegjegyzes,
      seattickets: seattickets,
      fizmodok: CONSTANTS.fizetesiModAzonositok,
    };

    const handlePdfLoaded = async (err, res) => {
      if (!err) {
        const blob = new Blob([res[0]], { type: "application/pdf" });
        const iframe = document.createElement("iframe");
        iframe.type = blob.type;
        iframe.src = URL.createObjectURL(blob);
        iframe.style.visibility = "hidden";

        document.body.appendChild(iframe);

        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        window.setTimeout(() => window.close(), 2000);
        window.setTimeout(() => {
          goBack();
          document.body.classList.remove("sidebar-hidden");
        }, 7000);

        addSuccess("Jegy nyomtatás!");
      }
      setFizetesButtonLoading(false);
    };

    if (rendelesId) {
      Services.sendAdminPurchasePayPrint(adminPurchaseDto, true, handlePdfLoaded);
    } else {
      Services.sendAdminPurchasePrint(
        adminPurchaseDto,
        true,
        eszkozazonosito,
        handlePdfLoaded
      );
    }
  }

  return (
    <Button
      style={{ marginBottom: 8, marginRight: 8 }}
      color="primary"
      type="button"
      disabled={fizetesButtonLoading}
      className="pull-right table-new-button"
      onClick={handlePayButtonClick}
    >
      Fizetés
    </Button>
  );
};

export default JegyeladasFizetesButton;
